import { v4 as uuidv4 } from "uuid";
import { useSelectedNotebookPageIdMap } from "../../page";
import { useAppIdMap } from "../../app";
import { useInsertBlock } from "../block";
import { useAddDevcontainers } from "../../devcontainer";
import { newDevcontainer } from "../../../types/devcontainer";
import { DevcontainerBlock } from "../../../types/notebook/note/block/devcontainer";
import { writeData } from "../../../api";
import { insertPageBlock } from "../../../api/page";

export const useInsertDevcontainerBlock = () => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  const { appId } = useAppIdMap();
  const insertBlock = useInsertBlock();
  const addDevcontainers = useAddDevcontainers();
  return async (config: { blockIndex: number }) => {
    const { blockIndex } = config;
    const devcontainerId = uuidv4();
    const dc = newDevcontainer({ appId: appId!, devcontainerId, name: "Devcontainer" });
    const block: DevcontainerBlock = {
      "block-id": uuidv4(), "app-id": appId!, "devcontainer-id": devcontainerId,
      type: "omega/query-omega/page/block/devcontainer/DevContainerBlock",
      "page-id": selectedNotebookPageId!,
    };
    addDevcontainers([dc]);
    insertBlock({ block, blockIndex });
    await writeData(dc);
    await insertPageBlock({ block, "block-index": blockIndex });
    return block;
  };
};
